/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from "react";
import useSocket from "./useSocket";

const useSocketEvent = (events) => {
    const { socket } = useSocket();

    const listenToEvents = useCallback(() => {
        if (events?.length && socket) {
            events.forEach(({ name, cb }) => {
                const handler = (data) => cb(data);
                socket.on(name, handler);

                return () => {
                    socket.off(name, handler);
                };
            });
        }
    }, []);

    useEffect(listenToEvents, []);

    return { socket };
};

export default useSocketEvent;
